import { combineReducers } from 'redux'
import carRim from './CarRimSearch/carRimSearchSlice'
import industryRim from './IndustryRimSearch/industryRimSearchSlice'
import truckRim from './TruckRimSearch/truckRimSearchSlice'

export default combineReducers({
	carRim,
	industryRim,
	truckRim
})